import FingerprintJS from '@fingerprintjs/fingerprintjs';

import {
  LOGIN_COOKIE_KEY,
  LOGIN_TOKEN_COOKIE_KEY,
  USER_ID,
  VISITOR_ID_COOKIE_KEY,
} from '../config';
// import { trackAction } from '@/context/track';
// import Bowser from 'bowser';
import { getUserTime } from '../login';

// export * from './bot';
// export * from './converMenu';
// export * from './desktop';
// export * from './file';
// export * from './markdown';
// export * from './tool';
// export * from './user';
// export * from './wechatLogin';

// export function detectOS(ua) {
//   const { parsedResult } = Bowser.getParser(ua || window.navigator.userAgent);

//   if (parsedResult.os.name === 'Android') {
//     return 'Android';
//   }

//   if (parsedResult.os.name === 'iOS') {
//     return 'iOS';
//   }

//   if (parsedResult.os.name === 'macOS') {
//     return 'macOS';
//   }

//   if (parsedResult.os.name === 'Windows') {
//     return 'Windows';
//   }

//   return 'unknown';
// }

// export function getBrowser() {
//   const { userAgent } = navigator;
//   let browser = '';

//   if (userAgent.match(/edg/i)) {
//     browser = 'Edge';
//   } else if (userAgent.match(/chrome|chromium|crios/i)) {
//     browser = 'Chrome';
//   } else if (userAgent.match(/firefox|fxios/i)) {
//     browser = 'Firefox';
//   } else if (userAgent.match(/safari/i)) {
//     browser = 'Safari';
//   } else if (userAgent.match(/opr\//i)) {
//     browser = 'Opera';
//   } else if (userAgent.match(/netscape/i)) {
//     browser = 'Netscape';
//   } else if (userAgent.match(/msie|trident/i)) {
//     browser = 'IE';
//   } else if (userAgent.match(/huaweibrowser/i)) {
//     browser = 'Huawei Browser';
//   } else {
//     browser = 'unknown';
//   }

//   return browser;
// }

// export function isWechat() {
//   if (typeof window === 'undefined' || !window.navigator) {
//     return false; // 服务端渲染时返回 false
//   }

//   const isWechatBrowser = /MicroMessenger/i.test(window.navigator.userAgent);
//   return isWechatBrowser;
// }

// // export const getDefaultBot = () => {
// //   const mapIds = {
// //     'ys-chat.wenxiaobai.com': 78,
// //     'ys-chat-normal.wenxiaobai.com': 75,
// //   };

// //   const { hostname } = globalThis?.location || {};

// //   return mapIds[hostname];
// // };

// export function changePageUnloadBh() {
//   if (typeof window === 'undefined') return;

//   window.addEventListener('beforeunload', function (event) {
//     event.stopImmediatePropagation();
//   });
// }

// export const okReg = /^2[0-9]*/;

export function setCookie(name: string, value: string, days: number) {
  console.log(
    'aaaaaaaaasetCookie1111',
    name,
    '当前页面:',
    window.location.href
  );
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  // 获取当前域名并设置为主域名
  const hostname = window.location.hostname;
  let domain = '';
  // 根据环境设置不同的域名策略
  if (hostname.includes('muset.ai')) {
    domain = '; domain=.muset.ai';
  } else if (hostname.includes('wenxiaobai.com')) {
    domain = '; domain=.wenxiaobai.com';
  } else if (hostname.includes('muset.local')) {
    domain = '; domain=.muset.local';
  }
  // 检查是否为HTTPS环境
  // const isSecure = window.location.protocol === 'https:';
  // const secureFlag = isSecure ? '; secure' : '';
  document.cookie = name + '=' + (value || '') + expires + '; path=/' + domain;
  console.log('aaaaaaaaasetCookie2222', document.cookie);
}

export function getCookie(name: string) {
  if (typeof document === 'undefined' || !document.cookie) {
    console.error('Cookies are not available in this environment.');
    return null;
  }

  const cookies = document.cookie.split('; ');
  for (const cookieStr of cookies) {
    const cookie = cookieStr.split('=');
    if (cookie[0] === name) {
      return cookie[1].toString();
    }
  }
  return '';
}

export function deleteCookie(name: string) {
  const hostname = window.location.hostname;

  // 删除当前域名的 cookie（不设置 domain）
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

  if (hostname.includes('muset.ai')) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.muset.ai`;
  } else if (hostname.includes('wenxiaobai.com')) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.wenxiaobai.com`;
  } else if (hostname.includes('muset.local')) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.muset.local`;
  }
}

export async function setLoginCookieInfo({
  auth,
  visitorId = '',
  expireDays = 90,
}) {
  let deviceId = visitorId;
  if (!deviceId) {
    deviceId = await getVisitorId();
  }
  console.log('aaaaaaaaasetLoginCookieInfo', auth);
  setCookie(
    LOGIN_COOKIE_KEY,
    encodeURIComponent(JSON.stringify(auth)),
    expireDays
  );
  setAuthByCookie(auth);
  setLoginTokenCookie({ token: auth?.token || '', expireDays });
  setCookie(USER_ID, auth?.user?.id || '', expireDays);
  setCookie(VISITOR_ID_COOKIE_KEY, deviceId, expireDays);
}

export function clearLoginCookieInfo() {
  deleteCookie(LOGIN_COOKIE_KEY);
  setAuthByCookie(null);
  deleteCookie(LOGIN_TOKEN_COOKIE_KEY);
  deleteCookie(VISITOR_ID_COOKIE_KEY);
  deleteCookie(USER_ID);
}

export function clearRepeatedLoginCookieInfo() {
  const cookies = Object.fromEntries(
    document.cookie.split('; ').map(pair => pair.split('='))
  );
  console.log('aaaaaaaaaacookies', cookies, document.cookie.split('; '));
  // deleteCookie(LOGIN_COOKIE_KEY);

  // deleteCookie(LOGIN_TOKEN_COOKIE_KEY);
  // deleteCookie(VISITOR_ID_COOKIE_KEY);
}

export function findDuplicateCookieKeys(cookieString: string) {
  // 解析所有 cookie 键值对
  const cookiePairs = cookieString.split(';').map(pair => {
    const trimmed = pair.trim();
    const [key, ...valueParts] = trimmed.split('=');
    return { key, value: valueParts.join('=') };
  });

  // 只保留指定的 cookie key
  const allowedKeys = new Set([
    LOGIN_COOKIE_KEY,
    LOGIN_TOKEN_COOKIE_KEY,
    VISITOR_ID_COOKIE_KEY,
    USER_ID,
  ]);
  const filteredPairs = cookiePairs.filter(({ key }) => allowedKeys.has(key));

  // 按 key 分组
  const grouped: Record<string, string[]> = {};
  filteredPairs.forEach(({ key, value }) => {
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(value);
  });

  // 找出出现多次的键并返回所有值
  const duplicates = Object.entries(grouped)
    .filter(([key, values]) => values.length > 1)
    .map(([key, values]) => ({
      key,
      count: values.length,
      values: values,
    }));

  return duplicates;
}

export function deleteCurrentDomainCookie() {
  document.cookie = `${LOGIN_COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `${LOGIN_TOKEN_COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `${VISITOR_ID_COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `${USER_ID}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function setParentDomainCookie(cookieString: string, expireDays = 90) {
  const cookiePairs = cookieString.split(';').map(pair => {
    const trimmed = pair.trim();
    const [key, ...valueParts] = trimmed.split('=');
    return { key, value: valueParts.join('=') };
  });
  cookiePairs.forEach(({ key, value }) => {
    if (key === USER_ID) {
      setCookie(USER_ID, value, expireDays);
    } else if (key === VISITOR_ID_COOKIE_KEY) {
      setCookie(VISITOR_ID_COOKIE_KEY, value, expireDays);
    } else if (key === LOGIN_TOKEN_COOKIE_KEY) {
      setCookie(LOGIN_TOKEN_COOKIE_KEY, value, expireDays);
    } else if (key === LOGIN_COOKIE_KEY) {
      setCookie(LOGIN_COOKIE_KEY, value, expireDays);
    }
  });
  // deleteCurrentDomainCookie();
}

// export function setCookieUser(key, value) {
//   const auth = getAuthByCookie();
//   if (auth && auth.user) {
//     auth.user[key] = value;
//   }

//   setLoginCookieInfo({ auth });
// }

// // 检查登录cookie是否格式错误，以及是否需要清除old deviceId/visitorId
// export async function checkIfClearLoginCookieInfo() {
//   const cookieVisitorId = getVisitorIdByCookie();
//   const cookieAuth = getAuthByCookie();
//   const isExistToken = !!(cookieAuth && cookieAuth.token);
//   const isExistVisitorId = !!cookieVisitorId;
//   const isCorrect =
//     (isExistToken && isExistVisitorId) || (!isExistToken && !isExistVisitorId);

//   const deviceId = await getVisitorId();
//   const isOldVersion = isOldDeviceId(deviceId);
//   if (isOldVersion) {
//     clearVisitorId();
//     // 全局局部变量也需要清空
//     visitorId = '';
//   }
//   const isToursit = !!(
//     cookieAuth &&
//     cookieAuth.user &&
//     cookieAuth.user.isTourist
//   );
//   trackAction('TOKEN_ACTION_CHECK_NEED_CLEAR', {
//     auth: JSON.stringify(cookieAuth),
//     loginToken: getLoginTokenCookie(),
//     visitorId: cookieVisitorId,
//     isCorrect,
//     isOldVersion,
//     isToursit,
//     isNeedClear: !isCorrect || (isOldVersion && isToursit),
//   });

//   return !isCorrect || (isOldVersion && isToursit);
// }

// export function getAgreementByName(agreements, name) {
//   // console.log(agreements);
//   if (Array.isArray(agreements)) {
//     for (let i = 0; i < agreements.length; ++i) {
//       const agree = agreements[i];
//       if (agree.name === name) {
//         return agree;
//       }
//     }
//   }

//   return null;
// }

// export function isOldDeviceId(deviceId) {
//   if (!deviceId) return false;
//   const arr = deviceId.split('_');
//   return arr.length === 1 && arr[0].length === 32;
// }

let visitorId = '';

function generateTimestampRandom() {
  const timestamp = Date.now(); // 获取当前时间戳
  const randomNum = Math.random(); // 生成一个0到1之间的随机数
  return `${timestamp}_${Math.floor(randomNum * 1000000)}`; // 组合时间戳和随机数
}

export async function getVisitorId() {
  if (!visitorId) {
    visitorId = localStorage.getItem('visitorId');

    if (!visitorId) {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      // 旧格式：7a3698a2dd0b08b6ded5dd740a73234d
      // 新的格式：7a3698a2dd0b08b6ded5dd740a73234d_1740319389540_256336
      visitorId = `${result.visitorId}_${generateTimestampRandom()}`;
      localStorage.setItem('visitorId', visitorId);
    }
  }

  return visitorId;
}

// export function clearVisitorId() {
//   localStorage.removeItem('visitorId');
// }

export function getVisitorIdByCookie() {
  return getCookie('visitorId');
}

// cookie中删除用户信息，使用模块状态代替用户信息，否则代码改动量很大
// 非理解不要轻易修改以下这段代码！！！！！
let cookieAuth = null;
export function setAuthByCookie(auth) {
  if (typeof window === 'undefined') return;
  console.log('当前 cookieAuth 设置为', auth);
  cookieAuth = auth;
}
export function getAuthByCookie() {
  if (typeof window === 'undefined') return;

  return cookieAuth;
  // const auth = getCookie('login');
  // try {

  //   const origin = decodeURIComponent(auth);
  //   // console.log(origin);
  //   const objAuth = JSON.parse(origin);
  //   return objAuth;
  // } catch (e) {
  //   return null;
  // }
}

export function getLoginTokenCookie() {
  if (typeof window === 'undefined') return;
  const loginToken = getCookie(LOGIN_TOKEN_COOKIE_KEY);
  return loginToken;
}

export function setLoginTokenCookie({
  token,
  expireDays = 90,
}: {
  token: string;
  expireDays?: number;
}) {
  if (typeof window === 'undefined') return;
  setCookie(LOGIN_TOKEN_COOKIE_KEY, token, expireDays);
}

// const getBase64 = (file) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = (error) => reject(error);
//   });

// export const handlePreview = async (file) => {
//   if (!file.url && !file.preview) {
//     file.preview = await getBase64(file.originFileObj);
//   }

//   return file.url || file.preview;
// };

// const chars =
//   '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_';

// export function randomString(length) {
//   let result = '';
//   for (let i = length; i > 0; --i)
//     result += chars[Math.floor(Math.random() * chars.length)];
//   return result;
// }

// export function getURLParameters(url) {
//   // 创建一个空对象来存储参数
//   var params = {};

//   // 获取问号后面的查询字符串部分
//   var queryString = url.split('?')[1];

//   // 检查是否存在查询字符串
//   if (queryString) {
//     // 将查询字符串分割成键值对
//     var keyValuePairs = queryString.split('&');

//     // 循环遍历键值对数组
//     for (var i = 0; i < keyValuePairs.length; i++) {
//       // 分割键值对
//       var pair = keyValuePairs[i].split('=');
//       // 将键和值存储到参数对象中
//       params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
//     }
//   }

//   return params;
// }

// export function getClientHeight() {
//   let screenHeight = 0;
//   if (typeof window !== 'undefined') {
//     screenHeight = window.visualViewport
//       ? window.visualViewport.height
//       : window.innerHeight;
//   }

//   return screenHeight;
// }

// export function getRandomElements(arr, numElements) {
//   // 创建一个数组的副本以避免修改原始数组
//   let tempArray = arr.slice();
//   let result = [];

//   for (let i = 0; i < numElements; i++) {
//     // 从tempArray随机选取一个索引
//     let index = Math.floor(Math.random() * tempArray.length);
//     // 将选定的元素添加到结果数组
//     result.push(tempArray[index]);
//     // 移除已选定的元素，确保不会重复选择
//     tempArray.splice(index, 1);
//   }

//   return result;
// }

// export function getEnvInBrowser() {
//   if (typeof navigator === 'undefined') return;

//   const { userAgent } = navigator;
//   return enviorment(userAgent.toLocaleLowerCase());
// }

// export function enviorment(sua) {
//   let env = '',
//     app = '';
//   if (/iphone|ipad|ipod/.test(sua)) {
//     env = 'ios';
//   } else if (/android/.test(sua)) {
//     env = 'android';
//   }

//   if (/MicroMessenger/i.test(sua)) {
//     app = 'wx';
//   }

//   return {
//     env,
//     app,
//   };
// }

// export function gotoStoreInBrowser({ env, app }) {
//   if (env === 'ios') {
//     window.location.href =
//       'https://apps.apple.com/cn/app/%E9%97%AE%E5%B0%8F%E7%99%BD/id6471236144';
//   } else if (env === 'android' && app === '') {
//     window.location.href =
//       'https://wy-andorid-dwn.wenxiaobai.com/apks/main/app-release-v1.2.0-4102045-main.apk';
//   } else if (env === '') {
//     //  PC
//     return;
//   }
// }

// const TIMEOUT_STORAGE = 'TIMEOUT_STORAGE';

// export function setSSETimeoutTurn(conversationId, turn) {
//   let org = getSSETimeoutTurn();
//   if (!org) {
//     org = {};
//   }

//   let conv = org[conversationId];
//   if (!conv) {
//     conv = {
//       conversationId,
//       turnList: [turn],
//     };
//   } else {
//     let finded = false;
//     for (let i = 0; i < conv.turnList.length; ++i) {
//       if (conv.turnList[i].turnId === turn.turnId) {
//         finded = true;
//         conv.turnList[i] = turn;
//         break;
//       }
//     }

//     if (!finded) {
//       conv.turnList.push(turn);
//     }
//   }

//   org[conversationId] = conv;
//   localStorage.setItem(TIMEOUT_STORAGE, JSON.stringify(org));
// }

// export function deleteSSETimeoutTurn(conversationId, turnId) {
//   let org = getSSETimeoutTurn();
//   if (org && org[conversationId]) {
//     const conv = org[conversationId];
//     conv.turnList = conv.turnList.filter((turn) => turn.turnId !== turnId);
//     org[conversationId] = conv;
//     localStorage.setItem(TIMEOUT_STORAGE, JSON.stringify(org));
//   }
// }

// export function getSSETimeoutTurn() {
//   try {
//     let org = localStorage.getItem(TIMEOUT_STORAGE);
//     return JSON.parse(org);
//   } catch (e) {
//     return null;
//   }
// }

// export function clearSSETimeoutTurn(conversationId) {
//   let org = getSSETimeoutTurn();
//   if (org) {
//     org[conversationId] = null;
//   }
//   localStorage.setItem(TIMEOUT_STORAGE, JSON.stringify(org));
// }

// function isNumberAndNotNaN(value) {
//   return typeof value === 'number' && !isNaN(value);
// }

// export function getConvCustomImgsCount(content) {
//   const reg = /``` ys_imgs.*?```/gs;
//   const regex2 = /header count (\d+)\n/;
//   const blocks = content.match(reg);
//   let ret = 0;
//   if (Array.isArray(blocks)) {
//     for (let i = 0; i < blocks.length; ++i) {
//       const oneMatch = blocks[i].match(regex2);
//       if (Array.isArray(oneMatch) && oneMatch.length > 1) {
//         let num = parseInt(oneMatch[1]);
//         if (isNumberAndNotNaN(num)) {
//           ret += num;
//         }
//       }
//     }
//   }

//   return ret;
// }

export const fetchData = async () => {
  try {
    const res = await getUserTime();
    if (res?.code === 0 && res?.data?.serverTimeMs) {
      const mistiming = res.data.serverTimeMs - Date.now();
      localStorage.setItem('mistiming', mistiming.toString());
    } else {
      // 接口返回非预期结果，设置 0 避免后续请求继续阻塞等待
      localStorage.setItem('mistiming', '0');
    }
  } catch (error) {
    console.error('Failed to fetch user time:', error);
    // 超时或失败时设置 0，避免每次 API 请求都重试 getUserTime
    localStorage.setItem('mistiming', '0');
  }
};
